import { CurrencyISOCode } from '@atlassiansox/bxp-use-pricing';
import React from 'react';
import { usePriceFinderStore } from '../../store';
import { UNIT_TRACKING_TERMS } from '../../utils';
import { PricingExampleDefault } from './pricing-example-default';
import { PricingExampleNoSelector } from './pricing-example-no-selector';

export interface PricingExampleContainerProps {
  unitTrackingTerm: UNIT_TRACKING_TERMS;
  pricingExampleUnitCounts: number[];
  hideBillingSelector: boolean;
  showFirstFlatRateTier: boolean;
  currencyISOCode: CurrencyISOCode;
}

const PricingExampleContainer = ({
  unitTrackingTerm,
  pricingExampleUnitCounts,
  hideBillingSelector,
  showFirstFlatRateTier,
  currencyISOCode
}: PricingExampleContainerProps) => {
  const [{ priceCalcs }] = usePriceFinderStore();
  const examplePriceCalc = priceCalcs[priceCalcs.length - 1];

  if (!examplePriceCalc) {
    throw new Error('Price calculation for pricing example was not found.');
  }

  return !hideBillingSelector ? (
    <PricingExampleDefault
      unitTrackingTerm={unitTrackingTerm}
      pricingExampleUnitCounts={pricingExampleUnitCounts}
      priceCalc={examplePriceCalc}
      showFirstFlatRateTier={showFirstFlatRateTier}
      currencyISOCode={currencyISOCode}
    />
  ) : (
    <PricingExampleNoSelector
      unitTrackingTerm={unitTrackingTerm}
      pricingExampleUnitCounts={pricingExampleUnitCounts}
      priceCalc={examplePriceCalc}
      showFirstFlatRateTier={showFirstFlatRateTier}
      currencyISOCode={currencyISOCode}
    />
  );
};

export { PricingExampleContainer };
